import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { ButtonTypeAttributeEnum } from '@hrra/ui';
import { ButtonTypeEnum } from '@hrra/ui';
import { filterSpecializations, loadSpecializations, removeSpecialization, resetSpecializationFilter, selectSpecialization, toggleExpandHeadSpecialization, unselectSpecialization } from 'src/app/root-store/jobseeker-store/specialization-picker/actions';
import { selectSystemConfigs } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';
import { Dictionary } from '@hrra/core';
import { SystemConfig } from 'src/app/shared/models/system-config-model';
import { Specialization } from '@hrra/common-models';
import { selectDisplayHeadSpecializationsSorted, selectDisplaySelectedSpecializationsTags, selectHeadSpecializationsExpandedMap, selectMaxSpecializationsReached, selectSpecializationsSelectedMap } from 'src/app/root-store/jobseeker-store/specialization-picker/selectors';
import { selectSpecializationsMap } from 'src/app/root-store/jobseeker-store/jobseeker-specialization/selectors';

@Component({
    selector: 'app-specialization-picker',
    templateUrl: './specialization-picker.component.html',
    styleUrls: ['./specialization-picker.component.scss'],
    standalone: false
})
export class SpecializationPickerComponent implements OnInit {
  navigationSubs: Subscription;

  public displayHeadSpecializations$: Observable<Specialization[]>;
  public headSpecializationExpandedMap$: Observable<Dictionary<boolean>>;
  public specializationsSelectedMap$: Observable<Dictionary<boolean>>;
  public allSpecializationsMap$: Observable<Dictionary<Specialization>>;
  public selectedSpecializationsDisplayTags$: Observable<Specialization[]>;
  public maxSpecializationsReached$: Observable<boolean>;
  public systemConfigs$: Observable<SystemConfig>;


  public buttonType: any;
  public buttonAttributeType: any;

  constructor(public dialogRef: MatDialogRef<SpecializationPickerComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private store: Store<AppState>, private router: Router) {
    this.buttonType = ButtonTypeEnum;
    this.buttonAttributeType = ButtonTypeAttributeEnum;

    this.navigationSubs = this.router.events.subscribe(e => {
      if(e instanceof NavigationEnd){
        this.dialogRef.close();
      }
    });
  }

  public onToggleExpandHeadSpecialization(head: Specialization){
    this.store.dispatch(toggleExpandHeadSpecialization({ payload: { specializationId: head.specializationId }}));
  }

  onToggleSpecialization(specializationId: string, event: MatCheckboxChange){
    if(event.checked){
      this.store.dispatch(selectSpecialization({ payload: { specializationId: specializationId }}));
    }
    else {
      this.store.dispatch(unselectSpecialization({ payload: { specializationId: specializationId }}));
    }
  }

  onRemoveSpecialization(specializationId: string){
    this.store.dispatch(removeSpecialization({ payload: { specializationId: specializationId }}));
  }

  onSearch(query: string){
    this.store.dispatch(filterSpecializations({ payload: { query: query }}));
  }

  onSave(specializations: Specialization[]){
    const specializationIds = specializations.map(c => c.specializationId);
    this.dialogRef.close(specializationIds);
  }

  onCancel(){
    this.dialogRef.close(null);
  }

  ngOnInit(): void {

    this.displayHeadSpecializations$ = this.store.pipe(select(selectDisplayHeadSpecializationsSorted));

    this.headSpecializationExpandedMap$ = this.store.pipe(select(selectHeadSpecializationsExpandedMap));
    this.specializationsSelectedMap$ = this.store.pipe(select(selectSpecializationsSelectedMap));
    this.allSpecializationsMap$ = this.store.pipe(select(selectSpecializationsMap));
    this.selectedSpecializationsDisplayTags$ = this.store.pipe(select(selectDisplaySelectedSpecializationsTags));
    this.maxSpecializationsReached$ = this.store.pipe(select(selectMaxSpecializationsReached));
    this.systemConfigs$ = this.store.pipe(select(selectSystemConfigs));

    setTimeout(() => {
      this.store.dispatch(resetSpecializationFilter());
      this.store.dispatch(loadSpecializations({ payload: { specializationIds: this.data.specializationIds }}));
    }, 0);
  }

  ngOnDestroy() {
    this.navigationSubs.unsubscribe();
  }
}